import { get } from 'lodash'
import moment from 'moment'

export const convertCollectionOptionsToArray = (options = []) => {
  const data = {}
  options.forEach((o) => {
    if (data[o.props._id]) {
      data[o.props._id].bucketIds.push(o.props.value)
    } else {
      data[o.props._id] = {
        _id: o.props._id,
        name: o.props.collectionName,
        type: o.props.type,
        bucketIds: [o.props.value],
      }
    }
  })

  return Object.values(data)
}

export const getAllRubricNames = (item = {}) => {
  const questions = get(item, 'data.questions', [])
  let rubricNames = []
  if (questions.length === 1 && questions[0]?.rubrics?.name) {
    rubricNames = [questions[0].rubrics.name]
  } else {
    rubricNames = questions.map((q, index) => {
      if (q?.rubrics?.name) {
        return `Q${index + 1}: ${q.rubrics.name}`
      }
      return ''
    })
  }
  return rubricNames.filter((name) => name)
}

export const getSearchParams = (searchParamToPick = 'all') => {
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParamToPick === 'all') {
    return searchParams.size > 0 ? { search: searchParams.toString() } : {}
  }
  return searchParams.has(searchParamToPick)
    ? {
        search: `${searchParamToPick}=${searchParams.get(searchParamToPick)}`,
      }
    : {}
}

export const getTestListFromVersionBucket = (searchResult) => {
  const testList = []
  const testVersionBuckets = get(
    searchResult,
    'aggregations.by_version.buckets',
    []
  )
  testVersionBuckets.forEach((versionBucket) => {
    const hasChildren = versionBucket.by_reportKey.buckets.length > 1
    versionBucket.by_reportKey.buckets.forEach((testBucket, index) => {
      const testId = testBucket.key
      const title = testBucket.assignments.hits.hits[0]._source.title
      testId &&
        title &&
        testList.push({
          _id: testId,
          title,
          hasChildren: index === 0 && hasChildren,
          isChild: index > 0,
          tooltipInfo: `| Assigned on ${moment(
            testBucket.assignments.hits.hits[0]._source.createdAt
          ).format('DD MMM, YYYY')}`,
        })
    })
  })
  return testList
}
